<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>授权帐号列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <router-link :to="{path:'/mail/accounts/save'}">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table border :data="accounts_list">
          <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
          <el-table-column prop="auth_code" label="授权码" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <router-link :to="{ path : '/mail/accounts/save', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>

              <el-button
                v-if="scope.row.is_del == 0"
                class="success"
                type="text"
                @click="deleteAccount(scope.row.id)"
                icon="el-icon-setting"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import JSEncrypt from 'jsencrypt'

export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 15,
      accounts_list: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getAccounts();
    },
    deleteAccount(id) {
      let _id = id;
      this.$confirm("是否删除当前授权帐号吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          url: "/email/accounts/delete",
          data:{
            id: _id,
          },
          type:"POST",
        }).then(res => {
          loading.close()
          this.$util.msg(res.msg, "success");
          setTimeout(() => {
            this.getAccounts();
          }, 1200);
        });
      })
      .catch(() => {});
    },
    getAccounts() {
      this.$ajax({
        url: "/email/accounts/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.accounts_list = data.data.data;
        this.total = data.data.count;
      });
    },
  },
  mounted() {
    this.getAccounts();
  },
};
</script>
<style>
</style>